import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';

import * as yup from 'yup';

/** New profile register API request body */
export interface ProfileRegisterInterface {
  /** Profile email (login) */
  email: string;
   /** User's first (personal) name */
  firstName: string;
  /** User's middle (additional) name or surname */
  middleName?: string;
  /** User's last (family) name */
  lastName?: string;
}

/** New profile register API request body - DTO schema */
export const ProfileRegisterDto = SerdeDtoClass.create<ProfileRegisterInterface>(SecurityDtoKeysEnum.PROFILE_REGISTER_DTO, {
  email: {
    label: 'Email',
    checkers: [SecurityBackendValidatorsEnum.PROFILE_EMAIL_UNIQUE],
    serializer: yup
      .string()
      .email(DtoMessageEnum.INCORRECT_EMAIL),
  },
  firstName: {
    label: 'Имя',
    serializer: nonEmptyStringSchema,
  },
  middleName: {
    optional: true,
    label: 'Отчество',
    serializer: yup.string(),
  },
  lastName: {
    optional: true,
    label: 'Фамилия',
    serializer: yup.string(),
  },
});
